export default __webpack_public_path__ + "static/AQP_Tips-260fe43f28b5a453a2a39fabc615c5e6.zip";